/* External */
import { Map, Record } from 'immutable';

/* Action Types */
import {
  REQUEST_CREATE,
  REQUEST_SUCCESS,
  REQUEST_FAILURE,
  REQUEST_DELETE,
  REQUEST_DELETE_MULTIPLE,
  REQUEST_SUCCESS_MULTIPLE,
  REQUEST_FAILURE_MULTIPLE,
} from './actionTypes';

/* Utils */
import { STATUS_TYPES } from '../../utils/constants';

export const RequestRecord = Record({
  id: '',
  status: STATUS_TYPES.UNLOAD_STATE,
  result: undefined,
});

export default function requestsReducer(state = Map(), { type, payload } = {}) {
  const {
    requestId,
    result,
    requestIds,
  } = payload || {};

  if (!requestId && !requestIds) return state;

  switch (type) {
    case REQUEST_CREATE: {
      const request = RequestRecord({
        id: requestId,
        status: STATUS_TYPES.INIT_STATE,
      });

      return state.set(requestId, request);
    }
    case REQUEST_SUCCESS: {
      const request = state.get(requestId);
      if (!request) return state;

      const newRequest = request.withMutations((mutableRequest) => {
        mutableRequest.set('status', STATUS_TYPES.SUCCEED_STATE);
        mutableRequest.set('result', result);
      });

      return state.set(requestId, newRequest);
    }
    case REQUEST_SUCCESS_MULTIPLE: {
      return state.withMutations((mutableState) => {
        for (const requestIdToUpdate of requestIds) {
          mutableState.setIn([requestIdToUpdate, 'status'], STATUS_TYPES.SUCCEED_STATE);
        }
      });
    }
    case REQUEST_FAILURE: {
      const request = state.get(requestId);
      if (!request) return state;

      const newRequest = request.withMutations((mutableRequest) => {
        mutableRequest.set('status', STATUS_TYPES.FAILED_STATE);
      });

      return state.set(requestId, newRequest);
    }
    case REQUEST_FAILURE_MULTIPLE: {
      return state.withMutations((mutableState) => {
        for (const requestIdToUpdate of requestIds) {
          mutableState.setIn([requestIdToUpdate, 'status'], STATUS_TYPES.FAILED_STATE);
        }
      });
    }
    case REQUEST_DELETE: {
      return state.delete(requestId);
    }

    case REQUEST_DELETE_MULTIPLE: {
      return state.withMutations((mutableState) => {
        for (const requestIdToDelete of requestIds) {
          mutableState.delete(requestIdToDelete);
        }
      });
    }
    default: {
      return state;
    }
  }
}
